export default __webpack_public_path__ + "static/media/toDateHistory.d2815996.png";